/**
 * EDGEFleet: macht den Footer-Link „Cookie Einstellungen" funktionsfähig.
 *
 * Der Shop nutzt Shopifys nativen Einwilligungsbanner
 * (`/cdn/shopifycloud/privacy-banner/storefront-banner.js`). Der stellt zum erneuten Öffnen
 * der Auswahl `window.privacyBanner.showPreferences()` bereit — eine JS-Funktion, keine URL.
 * Ein Shopify-Menüpunkt kann aber nur auf eine Adresse zeigen. Diese Datei schlägt die
 * Brücke: sie fängt den Klick auf den Menüpunkt ab und ruft die Funktion auf.
 *
 * Erkannt wird der Auslöser auf zwei Wegen, damit er auch dann greift, wenn das
 * Adressfeld in der Shopify-Navigation keinen reinen Anker akzeptiert:
 *   1. jede Adresse, die auf `#cookie-einstellungen` endet  (der saubere Weg)
 *   2. ein Link mit der Adresse `#`, dessen Beschriftung genau „Cookie Einstellungen" lautet
 *
 * Ist der Banner nicht geladen — etwa weil die Region des Besuchers keine Einwilligung
 * verlangt —, wird der Klick nicht abgefangen. Der Link verhält sich dann wie bisher,
 * es bricht nichts.
 */

const HASH = '#cookie-einstellungen';
const FALLBACK_LABEL = 'cookie einstellungen';

function isTrigger(link) {
  if (!link) return false;

  const href = (link.getAttribute('href') || '').trim();
  if (href.toLowerCase().endsWith(HASH)) return true;

  return href === '#' && link.textContent.trim().toLowerCase() === FALLBACK_LABEL;
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('a');
  if (!isTrigger(link)) return;

  const banner = window.privacyBanner;
  if (!banner || typeof banner.showPreferences !== 'function') return;

  event.preventDefault();
  banner.showPreferences();
});
